/**
 * @generated SignedSource<<fc806f27375ba559d72104dd3b1e5529>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion">;
  readonly " $fragmentType": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion";
};
export type issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$key = {
  readonly " $data"?: issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "4337c06001af5c62a61021cb3fd03fad";

export default node;
